import { lazy } from 'react';

// project imports
//import MinimalLayout from 'layout/MinimalLayout';
//import NavMotion from 'layout/NavMotion';

import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import { Navigate } from 'react-router-dom'; // Navigate 임포트 추가

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));

// utilities routing
const UtilsTypography = Loadable(lazy(() => import('views/utilities/Typography')));
const UtilsColor = Loadable(lazy(() => import('views/utilities/Color')));
const UtilsShadow = Loadable(lazy(() => import('views/utilities/Shadow')));
const UtilsMaterialIcons = Loadable(lazy(() => import('views/utilities/MaterialIcons')));
const UtilsTablerIcons = Loadable(lazy(() => import('views/utilities/TablerIcons')));

// sample page routing
const SamplePage = Loadable(lazy(() => import('views/sample-page')));

const Banners = Loadable(lazy(() => import('views/pages/banners')));
const BannerDetail = Loadable(lazy(() => import('views/pages/banners/BannerDetail')));
const BannerDetailGeneric = Loadable(lazy(() => import('views/pages/banners/BannerDetailGeneric')));
const Users = Loadable(lazy(() => import('views/pages/users')));
const UserDetail = Loadable(lazy(() => import('views/pages/users/UserDetail')));
const Technicians = Loadable(lazy(() => import('views/pages/technicians')));
const TechnicianDetail = Loadable(lazy(() => import('views/pages/technicians/TechnicianDetail')));
const ConstructionCompanys = Loadable(lazy(() => import('views/pages/constructionCompanys')));
const ConstructionCompanyDetail = Loadable(lazy(() => import('views/pages/constructionCompanys/ConstructionCompanyDetail')));
const MaterialSuppliers = Loadable(lazy(() => import('views/pages/materialSuppliers')));
const MaterialSupplierDetail = Loadable(lazy(() => import('views/pages/materialSuppliers/MaterialSupplierDetail')));
const Payments = Loadable(lazy(() => import('views/pages/payments')));
const PaymentDetail = Loadable(lazy(() => import('views/pages/payments/PaymentDetail')));
const FindTechnicians = Loadable(lazy(() => import('views/pages/findTechnicians')));
const FindTechnicianDetail = Loadable(lazy(() => import('views/pages/findTechnicians/FindTechnicianDetail')));
const RequestWorks = Loadable(lazy(() => import('views/pages/requestWorks')));
const RequestWorkDetail = Loadable(lazy(() => import('views/pages/requestWorks/RequestWorkDetail')));
const GeneralConfigDetail = Loadable(lazy(() => import('views/pages/generalConfigs/GeneralConfigDetail')));
const GeminiConfigDetail = Loadable(lazy(() => import('views/pages/generalConfigs/GeminiConfigDetail')));
const GeminiTabs = Loadable(lazy(() => import('views/pages/generalConfigs/GeminiTabs')));
const Applicants = Loadable(lazy(() => import('views/pages/applicants')));
const ApplicantDetail = Loadable(lazy(() => import('views/pages/applicants/ApplicantDetail')));
const WriteRequestWorks = Loadable(lazy(() => import('views/pages/writeRequestWorks')));
const WriteRequestWorkDetail = Loadable(lazy(() => import('views/pages/writeRequestWorks/WriteRequestWorkDetail')));
const JobPostings = Loadable(lazy(() => import('views/pages/jobPostings')));
const JobPostingDetail = Loadable(lazy(() => import('views/pages/jobPostings/JobPostingDetail')));
const InterviewOffers = Loadable(lazy(() => import('views/pages/interviewOffers')));
const InterviewOfferDetail = Loadable(lazy(() => import('views/pages/interviewOffers/InterviewOfferDetail')));
const Qnas = Loadable(lazy(() => import('views/pages/qnas')));
const QnaDetail = Loadable(lazy(() => import('views/pages/qnas/QnaDetail')));
const Trainees = Loadable(lazy(() => import('views/pages/trainees')));
const TraineeDetail = Loadable(lazy(() => import('views/pages/trainees/TraineeDetail')));
const EducationalInstitutions = Loadable(lazy(() => import('views/pages/educationalInstitutions')));
const EducationalInstitutionDetail = Loadable(lazy(() => import('views/pages/educationalInstitutions/EducationalInstitutionDetail')));
const InterviewOffersIsoffer = Loadable(lazy(() => import('views/pages/interviewOffersIsoffer')));
const InterviewOfferDetailIsoffer = Loadable(lazy(() => import('views/pages/interviewOffersIsoffer/InterviewOfferDetailIsoffer')));
const Markets = Loadable(lazy(() => import('views/pages/markets')));
const MarketDetail = Loadable(lazy(() => import('views/pages/markets/MarketDetail')));
const CompanyNewss = Loadable(lazy(() => import('views/pages/companyNewss')));
const CompanyNewsDetail = Loadable(lazy(() => import('views/pages/companyNewss/CompanyNewsDetail')));
const ConstructionDiarys = Loadable(lazy(() => import('views/pages/constructionDiarys')));
const ConstructionDiaryDetail = Loadable(lazy(() => import('views/pages/constructionDiarys/ConstructionDiaryDetail')));
const Recommenders = Loadable(lazy(() => import('views/pages/recommenders')));
const RecommenderDetail = Loadable(lazy(() => import('views/pages/recommenders/RecommenderDetail')));
const Tabs = Loadable(lazy(() => import('views/pages/Tabs')));
const BannerConstructonDetail = Loadable(lazy(() => import('views/pages/bannerConstructons/BannerConstructonDetail')));
const BannerMaterialSupplierDetail = Loadable(lazy(() => import('views/pages/bannerMaterialSuppliers/BannerMaterialSupplierDetail')));
const BannerEducationalinstitutionDetail = Loadable(lazy(() => import('views/pages/bannerEducationalinstitutions/BannerEducationalinstitutionDetail')));
const BannerToolComapnyDetail = Loadable(lazy(() => import('views/pages/bannerToolComapnys/BannerToolComapnyDetail')));
const BannerInteriorDetail = Loadable(lazy(() => import('views/pages/bannerInteriors/BannerInteriorDetail')));
const BannerManufacturingDetail = Loadable(lazy(() => import('views/pages/bannerManufacturings/BannerManufacturingDetail')));
const BannerGovernmentDetail = Loadable(lazy(() => import('views/pages/bannerGovernments/BannerGovernmentDetail')));
const Interiors = Loadable(lazy(() => import('views/pages/interiors')));
const InteriorDetail = Loadable(lazy(() => import('views/pages/interiors/InteriorDetail')));
const ToolComapnys = Loadable(lazy(() => import('views/pages/toolComapnys')));
const ToolComapnyDetail = Loadable(lazy(() => import('views/pages/toolComapnys/ToolComapnyDetail')));
const Manufacturings = Loadable(lazy(() => import('views/pages/manufacturings')));
const ManufacturingDetail = Loadable(lazy(() => import('views/pages/manufacturings/ManufacturingDetail')));
const PanelCompanyDetail = Loadable(lazy(() => import('views/pages/panelCompanys/PanelCompanyDetail')));
const HvacCompanyDetail = Loadable(lazy(() => import('views/pages/hvacCompanys/HvacCompanyDetail')));
const EtcCompanyDetail = Loadable(lazy(() => import('views/pages/etcCompanys/EtcCompanyDetail')));
const ProfileTabs = Loadable(lazy(() => import('views/pages/profiles/ProfileTabs')));
const Subscriptions = Loadable(lazy(() => import('views/pages/subscriptions')));
const UsageStats = Loadable(lazy(() => import('views/pages/usageStats')));
const SubscriptionDetail = Loadable(lazy(() => import('views/pages/subscriptions/SubscriptionDetail')));
const DuplicateCompanyInfos = Loadable(lazy(() => import('views/pages/duplicateCompanyInfos')));
const DuplicateCompanyInfoDetail = Loadable(lazy(() => import('views/pages/duplicateCompanyInfos/DuplicateCompanyInfoDetail')));
const GovernmentOffices = Loadable(lazy(() => import('views/pages/governmentOffices')));
const GovernmentOfficeDetail = Loadable(lazy(() => import('views/pages/governmentOffices/GovernmentOfficeDetail')));
const CalcTabs = Loadable(lazy(() => import('views/pages/calculators/CalcTabs')));
const CalcErrorReports = Loadable(lazy(() => import('views/pages/calcErrorReports')));
const CalcErrorReportDetail = Loadable(lazy(() => import('views/pages/calcErrorReports/CalcErrorReportDetail')));
const ArchiveTabs = Loadable(lazy(() => import('views/pages/archives/ArchiveTabs')));
const ArchiveDetail = Loadable(lazy(() => import('views/pages/archives/ArchiveDetail')));
const ArchiveTypeDetail = Loadable(lazy(() => import('views/pages/archiveTypes/ArchiveTypeDetail')));
const Reports = Loadable(lazy(() => import('views/pages/reports')));
const ReportDetail = Loadable(lazy(() => import('views/pages/reports/ReportDetail')));
const Translations = Loadable(lazy(() => import('views/pages/translations')));
const TranslationDetail = Loadable(lazy(() => import('views/pages/translations/TranslationDetail')));
const InstitutionDetail = Loadable(lazy(() => import('views/pages/institutions/InstitutionDetail')));
const Policys = Loadable(lazy(() => import('views/pages/policys')));
const PolicyDetail = Loadable(lazy(() => import('views/pages/policys/PolicyDetail')));
const Notices = Loadable(lazy(() => import('views/pages/notices')));
const NoticeDetail = Loadable(lazy(() => import('views/pages/notices/NoticeDetail')));



// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: <MainLayout />,
  children: [
    {
      path: '/', // 루트 경로
      element: <Navigate to="/dashboard" replace /> // 기본적으로 대시보드로 리디렉션
    },
    {
      path: '/dashboard',
      element: <DashboardDefault />
    },
    {
      path: '/users',
      element: <Users />
    },
    {
      path: '/user-detail',
      element: <UserDetail />
    },
    {
      path: '/banners/*', // '*'를 추가하여 서브 라우트를 허용
      element: <Tabs /> // Tabs로 변경
    },
    // {
    //   path: '/banners',
    //   element: <Banners />
    // },
    {
      path: '/banner-detail',
      element: <BannerDetail />
    },
    {
      path: '/banner-generic-detail',
      element: <BannerDetailGeneric />
    },
    {
      path: '/banner-constructon-detail',
      element: <BannerConstructonDetail />
    },
    {
      path: '/banner-material-supplier-detail',
      element: <BannerMaterialSupplierDetail />
    },
    {
      path: '/banner-educationalinstitution-detail',
      element: <BannerEducationalinstitutionDetail />
    },
    {
      path: '/banner-government-detail',
      element: <BannerGovernmentDetail />
    },
    {
      path: '/banner-tool-company-detail',
      element: <BannerToolComapnyDetail />
    },
    {
      path: '/banner-interior-detail',
      element: <BannerInteriorDetail />
    },
    {
      path: '/banner-manufacturing-detail',
      element: <BannerManufacturingDetail />
    },
    {
      path: '/profiles/*',
      element: <ProfileTabs />
    },
    {
      path: '/technician-detail',
      element: <TechnicianDetail />
    },
    {
      path: '/construction-company-detail',
      element: <ConstructionCompanyDetail />
    },
    {
      path: '/material-supplier-detail',
      element: <MaterialSupplierDetail />
    },
    {
      path: '/interior-detail',
      element: <InteriorDetail />
    },
    {
      path: '/tool-comapny-detail',
      element: <ToolComapnyDetail />
    },
    {
      path: '/manufacturing-detail',
      element: <ManufacturingDetail />
    },
    {
      path: '/panel-company-detail',
      element: <PanelCompanyDetail />
    },
    {
      path: '/hvac-company-detail',
      element: <HvacCompanyDetail />
    },
    {
      path: '/etc-company-detail',
      element: <EtcCompanyDetail />
    },
    {
      path: '/subscriptions',
      element: <Subscriptions />
    },
    {
      // 사용자 이용 통계 (메뉴: menu-items/dashboard.js 대시보드 아래)
      path: '/usage-stats',
      element: <UsageStats />
    },
    {
      path: '/subscription-detail',
      element: <SubscriptionDetail />
    },
    {
      path: '/payments',
      element: <Payments />
    },
    {
      path: '/payment-detail',
      element: <PaymentDetail />
    },
    {
      path: '/find-technicians',
      element: <FindTechnicians />
    },
    {
      path: '/find-technician-detail',
      element: <FindTechnicianDetail />
    }, {
      path: '/request-works',
      element: <RequestWorks />
    },
    {
      path: '/request-work-detail',
      element: <RequestWorkDetail />
    },
    {
      path: '/gemini-config-detail/*',
      element: <GeminiTabs />
    },
    {
      path: '/general-config-detail',
      element: <GeneralConfigDetail />
    },
    {
      path: '/applicants',
      element: <Applicants />
    },
    {
      path: '/applicant-detail',
      element: <ApplicantDetail />
    },
    {
      path: '/write-request-works',
      element: <WriteRequestWorks />
    },
    {
      path: '/write-request-work-detail',
      element: <WriteRequestWorkDetail />
    },
    {
      path: '/job-postings',
      element: <JobPostings />
    },
    {
      path: '/job-posting-detail',
      element: <JobPostingDetail />
    },
    {
      path: '/interview-offers',
      element: <InterviewOffers />
    },
    {
      path: '/interview-offer-detail',
      element: <InterviewOfferDetail />
    },
    {
      path: '/interview-offers-isoffer',
      element: <InterviewOffersIsoffer />
    },
    {
      path: '/interview-offer-detail-isoffer',
      element: <InterviewOfferDetailIsoffer />
    },
    {
      path: '/qnas',
      element: <Qnas />
    },
    {
      path: '/qna-detail',
      element: <QnaDetail />
    },
    {
      path: '/educational-institution-detail',
      element: <EducationalInstitutionDetail />
    },
    {
      path: '/institution-detail',
      element: <InstitutionDetail />
    },
    {
      path: '/trainee-detail',
      element: <TraineeDetail />
    },
    {
      path: '/markets',
      element: <Markets />
    },
    {
      path: '/market-detail',
      element: <MarketDetail />
    },
    {
      path: '/company-newss',
      element: <CompanyNewss />
    },
    {
      path: '/company-news-detail',
      element: <CompanyNewsDetail />
    },
    {
      path: '/construction-diarys',
      element: <ConstructionDiarys />
    },
    {
      path: '/construction-diary-detail',
      element: <ConstructionDiaryDetail />
    },
    {
      path: '/recommenders',
      element: <Recommenders />
    },
    {
      path: '/recommender-detail',
      element: <RecommenderDetail />
    },
    {
      path: '/duplicate-company-infos',
      element: <DuplicateCompanyInfos />
    },
    {
      path: '/duplicate-company-info-detail',
      element: <DuplicateCompanyInfoDetail />
    },
    {
      path: '/government-office-detail',
      element: <GovernmentOfficeDetail />
    },
    {
      path: '/calculators/*',
      element: <CalcTabs />
    },
    {
      path: '/calc-error-reports',
      element: <CalcErrorReports />
    },
    {
      path: '/calc-error-report-detail',
      element: <CalcErrorReportDetail />
    },
    {
      path: '/archives/*',
      element: <ArchiveTabs />
    },
    {
      path: '/archive-detail',
      element: <ArchiveDetail />
    },
    {
      path: '/archive-types',
      element: <Navigate to="/archives/types" replace />
    },
    {
      path: '/archive-type-detail',
      element: <ArchiveTypeDetail />
    },
    {
      path: '/reports',
      element: <Reports />
    },
    {
      path: '/report-detail',
      element: <ReportDetail />
    },
    {
      path: '/translations',
      element: <Translations />
    },
    {
      path: '/translation-detail',
      element: <TranslationDetail />
    },
    {
      path: '/policys',
      element: <Policys />
    },
    {
      path: '/policy-detail',
      element: <PolicyDetail />
    },
    {
      path: '/notices',
      element: <Notices />
    },
    {
      path: '/notice-detail',
      element: <NoticeDetail />
    },


  ]
};

export default MainRoutes;
